"use client"
import {
  LineChart
} from "./chunk-ZWA4FO4Q.mjs";

// src/components/area-chart.ts
import { mergeMultiStyle } from "@yamada-ui/core";
var AreaChart = mergeMultiStyle(
  LineChart,
  {
    baseStyle: {
      area: {}
    }
  }
)({ omit: ["line"] });

export {
  AreaChart
};
//# sourceMappingURL=chunk-PCQ3FDYY.mjs.map